export default {
  // API_ENDPOINT: "http://localhost:8000/api/"
  API_ENDPOINT: `https://thawing-scrubland-88648.herokuapp.com/api/`
};
